{
  "name": "termweb-pub-client",
  "version": "1.18.3",
  "engines": {
    "node": ">=20.0.0"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:hu": "ng serve --configuration=development-hu",
    "start:sv": "ng serve --configuration=development-sv",
    "start:de": "ng serve --configuration=development-de",
    "build": "ng build --localize",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "coverage": "ng test --coverage",
    "coverage2": "npm run coverage && node open-coverage.js",
    "lint": "ng lint",
    "sme": "ng build --source-map=true --named-chunks==true && source-map-explorer dist/twpub-client/browser/en/**/*.js",
    "docker:build": "docker build -t twpub-client .",
    "docker:run": "docker run -p 80:80 twpub-client"
  },
  "husky": {
    "hooks": {
      "pre-commit": "lint-staged"
    }
  },
  "lint-staged": {
    "**/*.ts": [
      "eslint --fix",
      "git add"
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.5",
    "@angular/cdk": "^21.2.3",
    "@angular/common": "^21.2.5",
    "@angular/compiler": "^21.2.5",
    "@angular/core": "^21.2.5",
    "@angular/forms": "^21.2.5",
    "@angular/localize": "^21.2.5",
    "@angular/material": "^21.2.3",
    "@angular/platform-browser": "^21.2.5",
    "@angular/platform-browser-dynamic": "^21.2.5",
    "@angular/router": "^21.2.5",
    "@ng-web-apis/common": "^2.1.0",
    "@openfeature/core": "^1.8.0",
    "@openfeature/web-sdk": "^1.5.0",
    "@popperjs/core": "^2.11.6",
    "ajv": "8.18.0",
    "angular-split": "^20.0.0",
    "bootstrap": "^5.2.2",
    "chalk": "^4.1.2",
    "cookieconsent": "^3.1.1",
    "keycloak-angular": "^21.0.0",
    "keycloak-js": "^25.0.6",
    "lodash-es": "^4.17.21",
    "marked": "^16.4.2",
    "mime": "^4.0.1",
    "ng-gallery": "^12.0.0",
    "ngx-cookieconsent": "^8.0.0",
    "ngx-infinite-scroll": "^21.0.0",
    "ngx-json-viewer": "^3.1.0",
    "ngx-logger": "^5.0.11",
    "ngx-markdown": "^21.0.0",
    "rxjs": "^7.5.7",
    "tippy.js": "^6.3.7",
    "ts-md5": "^1.3.1",
    "tslib": "^2.3.0",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-builders/jest": "^21.0.3",
    "@angular-eslint/builder": "^21.3.0",
    "@angular-eslint/eslint-plugin": "^21.3.0",
    "@angular-eslint/eslint-plugin-template": "^21.3.0",
    "@angular-eslint/schematics": "^21.3.0",
    "@angular-eslint/template-parser": "^21.3.0",
    "@angular-extensions/pretty-html-log": "^5.0.2",
    "@angular/build": "^21.2.3",
    "@angular/cli": "^21.2.3",
    "@angular/compiler-cli": "^21.2.5",
    "@eslint/js": "^10.0.1",
    "@testing-library/angular": "^19.1.0",
    "@testing-library/dom": "^10.0.0",
    "@testing-library/jest-dom": "^6.4.2",
    "@types/jest": "^30.0.0",
    "@types/lodash": "^4.14.186",
    "@types/node": "^22.0.0",
    "@types/testing-library__jest-dom": "^6.0.0",
    "@typescript-eslint/eslint-plugin": "^8.56.0",
    "@typescript-eslint/parser": "^8.56.0",
    "@typescript-eslint/utils": "^8.56.0",
    "eslint": "^9.26.0",
    "globals": "^17.4.0",
    "husky": "^8.0.1",
    "jest": "^30.2.0",
    "jest-environment-jsdom": "^30.2.0",
    "jest-preset-angular": "^16.0.0",
    "neostandard": "^0.13.0",
    "ng-mocks": "^14.2.4",
    "source-map-explorer": "^2.5.3",
    "ts-jest": "^29.1.2",
    "typescript": "^5.4.5"
  }
}
